import { render, staticRenderFns } from "./LockSalesOrderOverlay.vue?vue&type=template&id=80abd674&scoped=true&"
import script from "./LockSalesOrderOverlay.vue?vue&type=script&lang=js&"
export * from "./LockSalesOrderOverlay.vue?vue&type=script&lang=js&"
import style0 from "./LockSalesOrderOverlay.vue?vue&type=style&index=0&id=80abd674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80abd674",
  null
  
)

export default component.exports